// Module
var code = `<simple-table
    get-table-data="video.views_per_feature_table_data"
    caption-text="Таблица просмотров всех видео фичей"
    caption-url="https://confluencen.amt-games.com/pages/viewpage.action?pageId=51644168"
>
</simple-table>
`;
// Exports
module.exports = code;